import {generate} from "./Headless";
import {loadImage} from "./loadImage";

export default {
    open,
    generate,
    loadImage
};



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/image-inline-editor/index.ts
 **/